import React from 'react';
import { MessageSquare, Instagram, Twitter, Facebook, Mail, Phone, Youtube} from 'lucide-react';
import Image from '../images/bharat araku1.png'
import { useNavigate,  } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const coffeeworld = () => {
    window.scrollTo(0, 0);
    navigate("/CoffeeWorld")
  }
  const Origin = () => {
    window.scrollTo(0, 0);
    navigate("/")
  }

  const Origin1 = () => {
    window.scrollTo(2, 0);
    navigate("/")
  }

  const contact = () => {
    window.scrollTo(0, 0);
    navigate("/Contact")
  }

  const CancellationPolicy = () => {
    window.scrollTo(0, 0);
    navigate("/CancellationPolicy")
  }

  const Disclaimer = () => {
    window.scrollTo(0, 0);
    navigate("/Disclaimer")
  }
  const PrivacyPolicy = () => {
    window.scrollTo(0, 0);
    navigate("/PrivacyPolicy")
  }
  const TermsAndConditions = () => {
    window.scrollTo(0, 0);
    navigate("/Terms & Conditions")
  } 
  const product = () => {
    window.scrollTo(0, 0);
    navigate("/Product")
  }
  
  const Links = {
    color: '#D9CAB3',
    textDecoration: 'none',
    fontFamily: '"Source Sans Pro", sans-serif',
    transition: 'color 0.3s ease',
    cursor:"pointer"
  }

  return (
    <footer style={{
      backgroundColor: 'rgb(47, 84, 74)',  // #2C1810   #49281A
      color: '#E6D7B8',
      padding: '50px 20px 5px',
      position: 'relative',
    }}>
      <div style={{
        maxWidth: '95%',
        margin: '0 auto',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: '40px',
          marginBottom: '60px',
          '@media (min-width: 768px)': {
            gridTemplateColumns: 'repeat(2, 1fr)',
          },
          '@media (min-width: 992px)': {
            gridTemplateColumns: 'repeat(4, 1fr)',
          },
        }} className="md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px',
              background:"white",
              width:"100px",
              height:"100px",
              borderRadius:"50%"
              // padding:"10px" 
            }}>
              {/* <MessageSquare style={{ color: '#D2691E', marginRight: '10px' }} size={10} />
              <h2 style={{
                fontFamily: '"Playfair Display", serif',
                fontSize: '1.5rem',
                color: '#FFF8E1',
                margin: 0,
              }}>Bharat Araku</h2> */}
              <img src={Image} style={{height:"50px",width:"100px"}} alt="" />
            </div>
            <p style={{
              fontFamily: '"Source Sans Pro", sans-serif',
              lineHeight: 1.6,
              color: '#D9CAB3',
              marginBottom: '20px',
              textAlign:"justify"
            }}>
             We’d love to hear from you—whether it's a question, a thought, or just a hello over a cup of Araku.
            </p>
            <div style={{
              display: 'flex',
              gap: '15px',
            }}>
              <a href="https://www.instagram.com/magicroast_qoffee/" style={{
                width: '36px',
                height: '36px',
                backgroundColor: '#3C271C',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#D2691E',
                transition: 'all 0.3s ease',
                ':hover': {
                  backgroundColor: '#D2691E',
                  color: '#FFF8E1',
                  transform: 'translateY(-3px)',
                },
              }}>
                <Instagram size={18} />
              </a>
              <a href="https://www.youtube.com/@MagicroastQoffee" style={{
                width: '36px',
                height: '36px',
                backgroundColor: '#3C271C',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#D2691E',
                transition: 'all 0.3s ease',
                ':hover': {
                  backgroundColor: '#D2691E',
                  color: '#FFF8E1',
                  transform: 'translateY(-3px)',
                },
              }}>
                <Youtube size={18} />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61572673342331" style={{
                width: '36px',
                height: '36px',
                backgroundColor: '#3C271C',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#D2691E',
                transition: 'all 0.3s ease',
                ':hover': {
                  backgroundColor: '#D2691E',
                  color: '#FFF8E1',
                  transform: 'translateY(-3px)',
                },
              }}>
                <Facebook size={18} />
              </a>
            </div>
          </div>
          
          <div style={{marginLeft:"15%"}}>
            <h3 style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: '1.2rem',
              color: '#FFF8E1',
              marginBottom: '25px',
              position: 'relative',
            }}>
              Quick Links
              <span style={{
                position: 'absolute',
                bottom: '-8px',
                left: '0',
                height: '2px',
                width: '40px',
                backgroundColor: '#D2691E',
              }}></span>
            </h3>
            <ul style={{
              padding: 0,
              listStyle: 'none',
              margin: 0,
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={Origin} style={Links}>Home</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={coffeeworld} style={Links}>About Us</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={product} style={Links}>Products</a>
              </li>
              {/* <li style={{ marginBottom: '12px' }}>
                <a href="#" style={{
                  color: '#D9CAB3',
                  textDecoration: 'none',
                  fontFamily: '"Source Sans Pro", sans-serif',
                  transition: 'color 0.3s ease',
                  ':hover': {
                    color: '#D2691E',
                  },
                }}>Pricing</a>
              </li> */}
              <li>
                <a onClick={contact} style={Links}>Contact</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: '1.2rem',
              color: '#FFF8E1',
              marginBottom: '25px',
              position: 'relative',
            }}>
              Help & Support
              <span style={{
                position: 'absolute',
                bottom: '-8px',
                left: '0',
                height: '2px',
                width: '40px',
                backgroundColor: '#D2691E',
              }}></span>
            </h3>
            <ul style={{
              padding: 0,
              listStyle: 'none',
              margin: 0,
            }}>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={Origin1} style={Links}>FAQ</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={PrivacyPolicy} style={Links}>Privacy Policy</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={TermsAndConditions} style={Links}>Terms & Conditions</a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a onClick={CancellationPolicy} style={Links}>Cancellation Policy</a>
              </li>
              <li>
                <a onClick={Disclaimer} style={Links}>Disclaimer</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 style={{
              fontFamily: '"Playfair Display", serif',
              fontSize: '1.2rem',
              color: '#FFF8E1',
              marginBottom: '25px',
              position: 'relative',
            }}>
              Contact Us
              <span style={{
                position: 'absolute',
                bottom: '-8px',
                left: '0',
                height: '2px',
                width: '40px',
                backgroundColor: '#D2691E',
              }}></span>
            </h3>
            <ul style={{
              padding: 0,
              listStyle: 'none',
              margin: 0,
            }}>
              <li style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '15px',
              }}>
                <Mail size={16} style={{ color: '#D2691E', marginRight: '10px' }} />
                <a href="mailto:hello@Bharat Araku.com" style={{
                  color: '#D9CAB3',
                  textDecoration: 'none',
                  fontFamily: '"Source Sans Pro", sans-serif',
                  transition: 'color 0.3s ease',
                  ':hover': {
                    color: '#D2691E',
                  },
                }}>connect@magicroasstqoffee.com</a>
              </li>
              <li style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '15px',
              }}>
                <Phone size={16} style={{ color: '#D2691E', marginRight: '10px' }} />
                <a href="tel:+91 9011211111" style={{
                  color: '#D9CAB3',
                  textDecoration: 'none',
                  fontFamily: '"Source Sans Pro", sans-serif',
                  transition: 'color 0.3s ease',
                  ':hover': {
                    color: '#D2691E',
                  },
                }}>+91 90112 11111</a>
              </li>
            </ul>
            
            {/* <div style={{
              marginTop: '25px',
            }}>
              <h4 style={{
                fontFamily: '"Playfair Display", serif',
                fontSize: '1rem',
                color: '#FFF8E1',
                marginBottom: '15px',
              }}>Join Our Newsletter</h4>
              <div style={{
                display: 'flex',
              }}>
                <input 
                  type="email" 
                  placeholder="Your email address"
                  style={{
                    backgroundColor: '#3C271C',
                    border: 'none',
                    padding: '12px 15px',
                    fontFamily: '"Source Sans Pro", sans-serif',
                    fontSize: '0.95rem',
                    color: '#E6D7B8',
                    borderRadius: '6px 0 0 6px',
                    width: '100%',
                    outline: 'none',
                    '::placeholder': {
                      color: '#A38F77',
                    },
                  }}
                />
                <button style={{
                  backgroundColor: '#D2691E',
                  color: '#FFF8E1',
                  border: 'none',
                  padding: '12px 15px',
                  borderRadius: '0 6px 6px 0',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                  ':hover': {
                    backgroundColor: '#A0522D',
                  },
                }}>
                  Subscribe
                </button>
              </div>
            </div> */}
          </div>
        </div>
        
        <div style={{
          borderTop: '1px solid #3C271C',
          // paddingTop: '20px',
          padding:"0",
          margin:"0",
          textAlign: 'center',
          fontFamily: '"Source Sans Pro", sans-serif',
          color: '#A38F77',
          fontSize: '0.9rem',
        }}>
          <p>&copy; {new Date().getFullYear()} Bharat Araku Coffee. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;